module.exports = __webpack_public_path__ + "jay-7b593b9dcd4249b36beb.jpg";